export { DUMP_FORMAT_VERSION, serializeSafeJSSnapshot } from "./snapshot/dump-format.js";
export { dump, dumpCurrent } from "./snapshot/dump.js";
